import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCard } from "../../products/ui/styled";
import { TablePopularProducts } from "./TablePopularProducts";

export const PopularProducts = () => {
  return (
    <AdminMenuLayout
      pageDescription="Configura qué productos aparecen en la sección Populares de la app"
      title="Productos populares"
    >
      <WrapperCard bodyStyle={{ padding: "24px", display: "flex", flexDirection: "column", alignItems: "stretch", width: "100%" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 16px 0" }}>
          Productos en sección Populares
        </h2>
        <TablePopularProducts />
      </WrapperCard>
    </AdminMenuLayout>
  );
};
